export default __webpack_public_path__ + "static/media/logo.33c4e7ee.png";